// extracted by mini-css-extract-plugin
export default {"editButton":"EditIcon_editButton__Gye+f"};